import { render, staticRenderFns } from "./NuevaPlantilla.vue?vue&type=template&id=69c55527"
import script from "./NuevaPlantilla.vue?vue&type=script&lang=js"
export * from "./NuevaPlantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports